import {
  AUDIT_PROJECT_TYPE,
  CORPORATE_FINANCE_PROJECT_TYPE,
  FAS_PROJECT_TYPE,
} from "@/core/lib/constants";
import type { ProjectTypeRead } from "@/openapi";

export const DEPARTMENT_PROJECT_TYPES = [
  AUDIT_PROJECT_TYPE,
  CORPORATE_FINANCE_PROJECT_TYPE,
  FAS_PROJECT_TYPE,
] as const;

export type DepartmentProjectType = (typeof DEPARTMENT_PROJECT_TYPES)[number];

// a structural type (audit_client) is governed by another type's permission
// domain: its nodes group projects instead of holding work, so it is never a
// valid target for a role assignment or a promotion
export const isStructuralProjectType = (type: ProjectTypeRead): boolean =>
  type.permission_domain_id !== null;

export const structuralProjectTypeNames = (
  types: readonly ProjectTypeRead[] | undefined,
): ReadonlySet<string> =>
  new Set(
    (types ?? []).filter(isStructuralProjectType).map((type) => type.name),
  );
